import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-number-field',
  templateUrl: './number-field.component.html',
  styleUrl: './number-field.component.css'
})
export class NumberFieldComponent implements ICellRendererAngularComp {
  refresh(_params: ICellRendererParams): boolean {
    throw new Error('Method not implemented.');
  }
  params;

  agInit(params): void {
    this.params = params;
  }

  get displayNumberValue(): string {
    const context = this.params.context;
    const tempData = context.tempEditData?.[this.params.node.id];
    if (this.params.data.editable && tempData) {
      return tempData[this.params.colDef.field];
    }
    return this.params.data[this.params.colDef.field];
  }
  
  onNumberValueInput(newValue: string) {
    const context = this.params.context;
    const tempData = context.tempEditData?.[this.params.node.id];
    if (tempData) {
      tempData[this.params.colDef.field] = newValue;
    }
  }

  preventNonDigits(event: KeyboardEvent) {
    const char = event.key;
    if (!/^\d$/.test(char)) {
      event.preventDefault();
    }
  }

  sanitizePaste(event: ClipboardEvent) {
    const pastedText = event.clipboardData?.getData('text') ?? '';
    if (!/^\d+$/.test(pastedText)) {
      event.preventDefault(); // block the paste
    }
  }
}
